<template>
  <div class="time-slider">
    <TimeSliderItem v-for="(hour, key) in hours" :key="key" :hour=hour />
  </div>
</template>

<script>
import TimeSliderItem from './TimeSliderItem';

export default {
  components: { TimeSliderItem },

  props: {
    hours: Array,
  },

  computed: {
    slickOptions() {
      return {
        slidesToShow: this.hours.length,
        mobileFirst: true,
        arrows: false,
        infinite: true,
      };
    },
  },
};
</script>

<style lang="scss">
.time-slider {
  display: flex;
  justify-content: space-around;

  .time-slider-item {
    flex: 1;
    margin: 0;
    border-right: 1px solid #FFD8D8D8;
    text-align: center;
    font-size: 2vh;
    letter-spacing: -0.12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TimeSlider/TimeSliderList.vue